<h5 mat-dialog-title>Création d'un nouveau groupe</h5>

<div class="form-container">
  <h4>Données du groupe</h4>
  <div class="table">
    <div class="tr">
      <div class="td w100">
        <mat-form-field appearance="fill">
          <mat-label>GroupId</mat-label>
          <input matInput [(ngModel)]="newGroupInfos.groupId" required>
        </mat-form-field>
      </div>
    </div>
  </div>
  <h4>Données de l'utilisateur</h4>
  <div class="table">
    <div class="tr">
      <div class="td w50">
        <mat-form-field appearance="fill">
          <mat-label>Nom</mat-label>
          <input matInput [(ngModel)]="newGroupInfos.mainUserLastName" required>
        </mat-form-field>
      </div>
      <div class="td w50">
        <mat-form-field appearance="fill">
          <mat-label>Prénom</mat-label>
          <input matInput [(ngModel)]="newGroupInfos.mainUserFirstName" required>
        </mat-form-field>
      </div>
    </div>
    <div class="tr">
      <div class="td w100">
        <mat-form-field appearance="fill">
          <mat-label>Email</mat-label>
          <input matInput [(ngModel)]="newGroupInfos.mainUserEmail" required>
        </mat-form-field>
      </div>
    </div>
    <div class="tr">
      <div class="td w50">
        <mat-form-field appearance="fill">
          <mat-label>Niss</mat-label>
          <input matInput [(ngModel)]="newGroupInfos.mainUserInss">
        </mat-form-field>
      </div>
      <div class="td w50">
        <mat-form-field appearance="fill">
          <mat-label>Inami</mat-label>
          <input matInput [(ngModel)]="newGroupInfos.mainUserNihii">
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="buttons-container">
    <button mat-flat-button class="m5" color="primary" type="button" (click)="createGroup()">Créer</button>
    <button mat-raised-button class="m5" color="warn" type="button" (click)="closeDialog()">Annuler</button>
  </div>
</div>
